"use client";

import product1 from '../../public/solar.png'
import product2 from '../../public/solar2.png'
import product3 from '../../public/solar-light.png'
import product4 from '../../public/solar-battery.png'

import brand1 from '../../public/adani.png'
import brand2 from '../../public/waree.png'
import brand3 from '../../public/tata-power.png'
import brand4 from '../../public/UTL.png'

import Image from 'next/image'
import colors from '../../styles/colors'
import { useRouter } from 'next/navigation'

export default function BrandExplore() {
  const router = useRouter();

  const brands = [
    {
      key: "adani",
      brandImg: brand1,
      productImg: product1,
      bg: colors.gradientCyan,
    },
    {
      key: "waree",
      brandImg: brand2,
      productImg: product2,
      bg: colors.gradientGreen,
    },
    {
      key: "tata-power",
      brandImg: brand3,
      productImg: product3,
      bg: colors.gradientBlue,
    },
    {
      key: "utl",
      brandImg: brand4,
      productImg: product4,
      bg: colors.gradientRed,
    
    },
  ];

  return (
<div className="w-full xl:h-[145px] 2xl:h-[145px] xl:py-16 2xl:py-8 md:py-5 min-h-[150px] 
  grid xl:grid-cols-4 2xl:grid-cols-4 md:grid-cols-2 grid-cols-1 
  xl:gap-[4rem] 2xl:gap-[4rem] gap-10 
  place-items-center 
  xl:px-[2rem] 2xl:px-[2rem] px-4">
      {brands.map((brand, index) => (
        <div
  key={index}
  onClick={() => router.push(`/FilterProducts?brand=${brand.key}`)}
  className="md:max-w-[19.4rem] sm:min-w-[309px] w-full h-[4.3rem] p-2 relative shadow-md cursor-pointer flex justify-between items-center"
  style={{ backgroundImage: brand.bg }}
>
  {/* Left side: brand + text */}
  <div className="flex flex-col justify-start items-start gap-2">
    <Image
    src={brand.brandImg}
    className={`${brand.key === "utl" ? "w-[2rem]" : "w-[3rem]"} h-auto`}
    alt="brand"
  />
    <span className="text-white text-sm font-medium">Visit the brand store</span>
  </div>

  {/* Right side: product */}
  <Image
    src={brand.productImg}
    className="w-[80px] absolute right-0 bottom-0 h-[100px]"
    alt="product"
  />
</div>

      ))}
    </div>
  );
}
